import React from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Docs from './pages/Docs';
import ApiAccess from './pages/ApiAccess';
import Referral from './pages/Referral';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import SourceCode from './pages/SourceCode';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Conditions from './pages/Conditions';
import Disclaimer from './pages/Disclaimer';
import './App.css';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <ThemeProvider>
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="api-access" element={<ApiAccess />} />
            <Route path="referral" element={<Referral />} />
            <Route path="about" element={<About />} />
            <Route path="docs" element={<Docs />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="contact" element={<Contact />} />
            <Route path="source-code" element={<SourceCode />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="conditions" element={<Conditions />} />
            <Route path="disclaimer" element={<Disclaimer />} />
          </Route>
          {/* Dashboard redirects to external HTML page */}
          <Route path="dashboard" element={<DashboardRedirect />} />
        </Routes>
      </HashRouter>
    </ThemeProvider>
  );
}

// Redirect to HTML dashboard (now in /terminal/)
const DashboardRedirect = () => {
  React.useEffect(() => {
    const base = window.location.href.split('#')[0].replace(/\/[^/]*$/, '/');
    window.location.href = base + 'terminal/';
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-primary)]">
      <p className="text-[var(--text-secondary)]">Loading Terminal...</p>
    </div>
  );
};

export default App;
